'use strict';

export const assetsFolder = 'assets/';
export const imgagesFolder = 'assets/images/';
